import { useWatch } from 'react-hook-form'
import { useFeatureFlags, useShop } from '../../../../../hooks'
import { AppointmentFormData } from '../../../../../types'
import { getIsCabinOnlyConfiguration } from '../../../../../util'

/**
 * Hook: returns whether the current shop uses CABIN_ONLY configuration for the journey's delivery model.
 * Feature applies only when ENABLE_SHOP_DELIVERY_MODEL_CONFIGURATION feature flag is enabled.
 * Falls back to false if shop config is missing or doesn't match the journey's delivery model.
 * Must be used within the appointment form context (journey from form state) and where useShop/useFeatureFlags are available.
 */
const useIsCabinOnlyConfiguration = (): boolean => {
  const { shop } = useShop()
  const [isShopDeliveryModelConfigurationEnabled] = useFeatureFlags<boolean>(['ENABLE_SHOP_DELIVERY_MODEL_CONFIGURATION'])
  const [optionalJourney] = useWatch<AppointmentFormData>({ name: ['journey'] })
  const journey = optionalJourney as string | undefined
  return Boolean(isShopDeliveryModelConfigurationEnabled && getIsCabinOnlyConfiguration(shop, journey))
}

export { useIsCabinOnlyConfiguration }
